/* Imports happen in Gulp */
$(document).ready(function(){

  WebFont.load({
    google: {
      families: ['Lato:300,400,700']
    }
  });

  $('.review-wrap').masonry({
    columnWidth: '.single-review',
    itemSelector: '.single-review',
    percentPosition: true
  });

  // init Masonry
  var $grid = $('.services-wrap').masonry({
    columnWidth: '.single-service',
    itemSelector: '.single-service',
    percentPosition: true
  });

  $grid.imagesLoaded().progress( function() {
    $grid.masonry('layout');
  });

  // init Masonry
  var $grid2 = $('.block-wrap').masonry({
    columnWidth: '.single-block',
    itemSelector: '.single-block',
    percentPosition: true
  });

  $grid2.imagesLoaded().progress( function() {
    $grid2.masonry('layout');
  });

  $(".devbuild__elemental__models__elementtestimonials .review-carousel").slick({
    slidesToShow: 1,
    infinite: true,
    responsive: [{
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
          infinite: true
        }
      },{
        breakpoint: 760,
        settings: {
          slidesToShow: 1,
          infinite: true
        }
      }],
    prevArrow: "<button class='prev'><i class='fa fa-angle-left'></i></button>",
    nextArrow: "<button class='next'><i class='fa fa-angle-right'></i></button>"
  });

  $(".devbuild__elemental__models__elementservices .block-carousel").slick({
    slidesToShow: 4,
    infinite: true,
    responsive: [{
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          infinite: true
        }
      },{
        breakpoint: 760,
        settings: {
          slidesToShow: 1,
          infinite: true
        }
      }],
    prevArrow: "<button class='prev'><i class='fa fa-angle-left'></i></button>",
    nextArrow: "<button class='next'><i class='fa fa-angle-right'></i></button>"
  });

  $(".devbuild__elemental__models__elementblocks .block-carousel").slick({
    slidesToShow: 4,
    infinite: true,
    responsive: [{
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          infinite: true
        }
      },{
        breakpoint: 760,
        settings: {
          slidesToShow: 1,
          infinite: true
        }
      }],
    prevArrow: "<button class='prev'><i class='fa fa-angle-left'></i></button>",
    nextArrow: "<button class='next'><i class='fa fa-angle-right'></i></button>"
  });

  var $slides = $('[data-slides]');
  var images = $slides.data('slides');
  if(images){
    $(".banner-content").backstretch(images, {
      duration: 4000,
      transition: 'fade',
      transitionDuration: 'normal',
    });
  }

});
